import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

import { Page, Container, ContentHeader } from 'components'
import { ProfilesForm } from 'components/Profiles'

import { routes } from 'Routes'
import constants from 'constants/index'

const UserProfilesNew = () => {
  const { pathname } = useLocation()

  const isAdvisor = pathname === routes.userProfiles.newOrganizations

  return (
    <Page title="Novo perfil">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Novo"
          menu={`Perfis ${isAdvisor ? 'Advisor' : 'de usuário'}`}
          subtitle={`Novo perfil ${isAdvisor ? 'advisor' : 'de usuário'}`}
        />
        <ProfilesForm
          profileType={
            isAdvisor
              ? constants.user.PROFILE_TYPE_ADVISOR
              : constants.user.PROFILE_TYPE_CLIENT
          }
        />
      </Container>
    </Page>
  )
}

export default UserProfilesNew
